<template>
  <div class="form-block">

    <div class="">
      <h2>Dane kontaktowe osoby wypełniającej formularz deklaracji</h2>
    </div>

    <div class="">
      <div class="">
        <label>
          <input
            type="radio"
            :value="true"
            v-model="isOwner"
            @change="emitChange"
          >
          Właściciel / Współwłaściciel
        </label>
      </div>
      <div class="">
        <label>
          <input
            type="radio"
            :value="false"
            v-model="isOwner"
            @change="emitChange"
          >
          Zarządzający
        </label>
      </div>
      <div class="">
        <label>
          <input
            class="text-input"
            style="width: 30rem"
            type="text"
            @change="emitChange"
            v-model="name"
          />
          Imię i nazwisko wypełniającego lub nazwa instytucji/firmy
        </label>
      </div>
      <div class="">
        <label>
          <input
            class="text-input"
            style="width: 22rem"
            type="text"
            @change="emitChange"
            v-model="phone"
            onkeypress="return (/[0-9,\+]/i.test(String.fromCharCode(event.which))) ? true : false"
          />
          Telefon kontaktowy (opcjonalne)
        </label>
      </div>
      <div class="">
        <small>Możesz podać kilka numerów oddzielonych przecinkami, np. +48123123123,224564564</small><br />
      </div>
      <div class="">
        <label>
          <input
            class="text-input"
            style="width: 30rem"
            type="text"
            @change="emitChange"
            v-model="email"
          />
          Adres poczty elektronicznej (opcjonalne)
        </label>
      </div>
    </div>
    <div class="">
      <h2>Dane adresowe osoby wypełniającej formularz deklaracji</h2>
    </div>
    <div class="">
      <div class="">
        <label>
          <input
            type="radio"
            :value="true"
            v-model="isAddressSame"
            @change="emitChange"
          >
          Dane są tożsame z adresem budynku/lokalu, którego dotyczy formularz
        </label>
      </div>
      <div class="">
        <label>
          <input
            type="radio"
            :value="false"
            v-model="isAddressSame"
            @change="emitChange"
          >
          Dane nie są tożsame z adresem budynku/lokalu, którego dotyczy formularz
        </label>
      </div>
    </div>
    <div class="">
      <div class="">
        <label>
          <input
            type="checkbox"
            v-model="hasStatement"
            @change="emitChange"
            :class="{
                'error': errors.hasStatement
            }"
          >
          Jestem świadomy odpowiedzialności karnej za złożenie fałszywego oświadczenia. Klauzula ta zastępuje pouczenie organu o odpowiedzialności karnej za składanie fałszywego oświadczenia.
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import Common from "@/components/declarations/validators/Common";

export default {
  name: "ThirdScreen",
  mixins: [Common],
  data() {
    return {
      isAddressSame: true,
      isOwner: true,
      email:  this.$store.state.currentUserData.email,
      phone: "",
      name: this.$store.state.currentUserData.full_name,
      hasStatement: false,

      isPoland: true,
      countryName: ''
    }
  },

  methods: {
    setData(data) {
      this.phone = data.contact_telephone_D03;
      this.email = data.email_D04;
      this.name = data.person_or_company_name_D02;
      this.isOwner = !data.is_manager_D01;
      this.isAddressSame = !data.is_address_different_D05;
      this.hasStatement = (data.has_statement) ? data.has_statement : false;
    },

    emitChange() {
      const data = {
        email: this.email,
        phone: this.phone,
        name: this.name,
        isOwner: this.isOwner,
        isAddressSame: this.isAddressSame,
        hasStatement: this.hasStatement
      };
      this.$emit('update', data);
    },
  },
}
</script>

<style scoped>
h1, h2, h3, h4, label, p {
  color: #707070;
}

h2 {
  font-size: 1.2rem;
  font-family: "Volte Semibold", serif;
}

input[type=text] {
  height: 2rem;
}

.text-input {
  margin-right: 1rem;
}

.form-block {
  overflow-y: auto;
}

input[type=checkbox].error, input[type=checkbox].error:before {
  outline: 2px solid #f10;
}

@media screen and (max-width: 768px) {
  .text-input {
    width: 100% !important;
  }
}
</style>
